// extracted by mini-css-extract-plugin
module.exports = {"container":"q_x","containerText":"q_Y","containerForm":"q_Z","contacting":"q_0","header":"q_1","media":"q_2","containerMedia":"q_3"};